import type en from './en';

type Messages = Record<keyof typeof en, string>;

const kn: Messages = {
  'board.return.context': 'ಮತ್ತೊಂದು ಕೆಲಸಕ್ಕೆ ಸಹಾಯ',
  'board.return.helping': 'ಈ ಕೆಲಸ {owner} ಅವರಿಗೆ ಸಹಾಯ ಮಾಡುತ್ತಿದೆ: {title}',
  'board.return.action': 'ನನ್ನ ಭಾಗ ಮುಗಿದಿದೆ — ಕೋರಿದವರಿಗೆ ಹಿಂದಿರುಗಿಸಿ',
  'board.return.guidance': 'ಇದು ಸಹಾಯಕ ಕೆಲಸವನ್ನು ನಿಮ್ಮ ಬೋರ್ಡ್‌ನಿಂದ, ಮುಗಿದ ಕೆಲಸಗಳ ವಿಭಾಗದಿಂದಲೂ ತೆಗೆದುಹಾಕಿ ಅದರ ಇತಿಹಾಸವನ್ನು ಉಳಿಸುತ್ತದೆ. ನಿಮ್ಮ ಸಂದೇಶ ಕೋರಿದವರ ಮೂಲ ಕೆಲಸಕ್ಕೆ ಹೋಗುತ್ತದೆ. ಎಲ್ಲ ಸಹಾಯಕ ಕೆಲಸಗಳು ಮುಗಿದು ಹೊರಗಿನ ನಿರೀಕ್ಷೆ ಇಲ್ಲವಾದಾಗ ಅವರ ಕೆಲಸ ನಡೆಯುತ್ತಿದೆ ವಿಭಾಗಕ್ಕೆ ಮರಳುತ್ತದೆ.',
  'board.return.messageRequired': 'ಹಿಂದಿರುಗಿಸುವ ಮೊದಲು ಕೆಳಗಿನ “ಏನು ಬದಲಾಗಿದೆ?” ಎಂಬಲ್ಲಿ ಅಗತ್ಯ ಸಂದೇಶ ಬರೆಯಿರಿ.',
  'board.return.confirm': 'ಈ ಸಹಾಯಕ ಕೆಲಸವನ್ನು ನಿಮ್ಮ ಬೋರ್ಡ್‌ನಿಂದ ತೆಗೆದುಹಾಕಿ {owner} ಅವರಿಗೆ ಸಂದೇಶ ಕಳುಹಿಸಬೇಕೇ: {title}? ಇತಿಹಾಸ ಉಳಿಯುತ್ತದೆ. ಕೋರಿದವರ ಮೂಲ ಕೆಲಸವನ್ನು ಮುಗಿದಿದೆ ಎಂದು ಗುರುತಿಸುವುದಿಲ್ಲ.',
  'board.return.blockers': 'ಬಗೆಹರಿಯದ ಅವಲಂಬನೆಗಳು',
  'board.return.resolveFirst': 'ಈ ಕೆಲಸವನ್ನು ಮುಗಿಸುವ, ಹಿಂದಿರುಗಿಸುವ ಅಥವಾ ಅಳಿಸುವ ಮೊದಲು ಈ ಅವಲಂಬನೆಗಳನ್ನು ಬಗೆಹರಿಸಿ.',
  'board.return.parentSelected': 'ಈ ವ್ಯಕ್ತಿ ನಿಮ್ಮ ಸಹಾಯ ಕೋರಿದ್ದಾರೆ. ಅವರಿಗೆ ಮತ್ತೆ ಸಹಾಯಕ ಕೆಲಸ ರಚಿಸಬೇಡಿ. ನಿಮ್ಮ ಭಾಗ ಮುಗಿದಿದ್ದರೆ “ನನ್ನ ಭಾಗ ಮುಗಿದಿದೆ — ಕೋರಿದವರಿಗೆ ಹಿಂದಿರುಗಿಸಿ” ಬಳಸಿ.',
  'myDay.heading': 'ನನ್ನ ದಿನ',
  'myDay.welcome': 'ಹಾಜರಾತಿ ದಾಖಲಿಸಿ, ಒಂದು ಹೆಜ್ಜೆ ಮುಂದಿಡಿ, ತಂಡಕ್ಕೆ ತಿಳಿಸಿ.',
  'myDay.title': 'ಕೆಲಸವನ್ನು ಮುಂದುವರಿಸೋಣ',
  'myDay.hint': 'ಮೊದಲು ಗಡುವಿನ ಕೆಲಸ, ನಂತರ ನಡೆಯುತ್ತಿರುವ ಕೆಲಸ.',
  'myDay.next': 'ಮುಂದೆ ಪರಿಶೀಲಿಸಬೇಕಾದದ್ದು',
  'myDay.completed': 'ಇಂದು {n} ಕೆಲಸಗಳು ಪೂರ್ಣಗೊಂಡಿವೆ',
  'myDay.open': 'ನಿಮ್ಮ ಬೋರ್ಡ್‌ನಲ್ಲಿ {n} ಬಾಕಿ ಕೆಲಸಗಳು',
  'myDay.progressHint': 'ಪೂರ್ಣಗೊಂಡ ಕೆಲಸಗಳಿಗೆ ಇಂದಿನ IST ದಿನಾಂಕ ಬಳಸಲಾಗುತ್ತದೆ. ಬಾಕಿ ಕೆಲಸಗಳು ಸಂಪೂರ್ಣ ಪಟ್ಟಿ, ದೈನಂದಿನ ಗುರಿಯಲ್ಲ.',
  'myDay.emptyHint': 'ಸ್ವಲ್ಪ ಬಿಡುವು. ಸಿದ್ಧರಾದಾಗ ಕೆಲಸ ಸೇರಿಸಿ.',
  'myDay.loadError': 'ಕೆಲಸಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ. ನಿಮ್ಮ ಹಾಜರಾತಿಗೆ ಪರಿಣಾಮವಿಲ್ಲ.',
  'myDay.start': 'ಕೆಲಸ ಪ್ರಾರಂಭಿಸಿ',
  'myDay.update': 'ತ್ವರಿತ ಅಪ್‌ಡೇಟ್',
  'myDay.finish': 'ಪೂರ್ಣಗೊಂಡಿದೆ ಎಂದು ಗುರುತಿಸಿ',
  'myDay.help': 'ಕಾಯುತ್ತಿದ್ದೇನೆ / ಸಹಾಯ ಬೇಕು',
  'myDay.showAll': 'ಎಲ್ಲಾ {n} ಬಾಕಿ ಕೆಲಸಗಳನ್ನು ನೋಡಿ',
  'myDay.showLess': 'ಕಡಿಮೆ ಕೆಲಸಗಳನ್ನು ತೋರಿಸಿ',
  'myDay.add': 'ಇನ್ನೇನು ಮಾಡಬೇಕು?',
  'myDay.reviewTitle': 'ಪಂಚ್ ಔಟ್ ಆಗಿದೆ. ಚಿಕ್ಕ ಪರಿಶೀಲನೆ?',
  'myDay.reviewHint': 'ಪೂರ್ಣಗೊಂಡ ಕೆಲಸಗಳನ್ನು ಮಾತ್ರ ಆಯ್ಕೆಮಾಡಿ. ಉಳಿದವುಗಳ ಸ್ಥಿತಿ ಮತ್ತು ಗಡುವು ಬದಲಾಗದೆ ಮುಂದಿನ ದಿನಕ್ಕೆ ಬಾಕಿ ಉಳಿಯುತ್ತವೆ.',
  'myDay.planHint': 'ಪ್ರಾರಂಭಿಸಲು ಕೆಲಸ ಆಯ್ಕೆಮಾಡಿ ಅಥವಾ ನಡೆಯುತ್ತಿರುವುದನ್ನು ಮುಂದುವರಿಸಿ. ಆಯ್ಕೆ ಮಾಡದ ಕೆಲಸಗಳು ಬದಲಾಗುವುದಿಲ್ಲ — ಯಾವುದೂ ಪೂರ್ಣಗೊಂಡಂತೆ ಗುರುತಿಸಲಾಗುವುದಿಲ್ಲ.',
  'myDay.later': 'ಇದನ್ನು ನಂತರ ಮಾಡುತ್ತೇನೆ',
  'myDay.carryForward': 'ಉಳಿದ ಎಲ್ಲಾ ಕೆಲಸಗಳನ್ನು ಬಾಕಿ ಇಡಿ',
  'myDay.completeSelected': 'ಆಯ್ಕೆ ಮಾಡಿದವುಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ ({n})',
  'board.seen': 'ನೋಡಲಾಗಿದೆ {date}',
  'board.delivered': 'ತಲುಪಿಸಲಾಗಿದೆ',
  'board.due.label': 'ಗಡುವು',
  'board.due.optional': 'ಗಡುವಿನ ದಿನಾಂಕ (ಐಚ್ಛಿಕ)',
  'board.due.overdue': 'ಗಡುವು ಮೀರಿದೆ',
  'board.due.today': 'ಇಂದು ಗಡುವು',
  'board.date.today': 'ಇಂದು',
  'board.date.tomorrow': 'ನಾಳೆ',
  'board.date.friday': 'ಈ ಶುಕ್ರವಾರ',
  'board.date.monday': 'ಮುಂದಿನ ಸೋಮವಾರ',
  'board.updates.title': 'ಕಾರ್ಡ್ ನವೀಕರಣ',
  'board.updates.prompt': 'ಏನು ಬದಲಾಗಿದೆ?',
  'board.updates.waitingOn': 'ಯಾರಿಗಾಗಿ ಕಾಯುತ್ತಿದ್ದೀರಿ (ಐಚ್ಛಿಕ)',
  'board.updates.nextFollowup': 'ಮುಂದಿನ ಅನುಸರಣೆ (ಐಚ್ಛಿಕ)',
  'board.updates.timeline': 'ನವೀಕರಣಗಳ ಇತಿಹಾಸ',
  'board.updates.add': 'ನವೀಕರಣ ಸೇರಿಸಿ',
  'board.updates.empty': 'ಇನ್ನೂ ನವೀಕರಣಗಳಿಲ್ಲ.',
  'board.updates.unavailable': 'ಈ ಕಾರ್ಡ್ ಲಭ್ಯವಿಲ್ಲ ಅಥವಾ ನಿಮಗೆ ಪ್ರವೇಶವಿಲ್ಲ.',
  'board.updates.status': 'ಸ್ಥಿತಿ',
  'board.status.on_track': 'ಸರಿಯಾದ ಹಾದಿಯಲ್ಲಿ',
  'board.status.waiting': 'ಕಾಯುತ್ತಿದೆ',
  'board.status.blocked': 'ತಡೆಹಿಡಿಯಲಾಗಿದೆ',
  'board.status.done': 'ಪೂರ್ಣಗೊಂಡಿದೆ',
  'board.reminders.title': 'Omar ನಿಂದ',
  'board.reminders.nudged': 'ನವೀಕರಣವನ್ನು ಕೇಳಲಾಗಿದೆ.',
  'board.reminders.empty': 'ಈಗ ಯಾವುದೇ ಪ್ರಗತಿ ಪರಿಶೀಲನೆ ಅಗತ್ಯವಿಲ್ಲ.',
  'board.reminders.dismiss': 'ಇಂದಿಗೆ ಮುಚ್ಚಿ',
  'board.quick.start': 'ಇನ್ನೂ ಕೆಲಸ ಮಾಡುತ್ತಿದ್ದೇನೆ',
  'board.quick.done': 'ಪೂರ್ಣಗೊಂಡಿದೆ',
  'board.quick.text.on_track': 'ಇದರ ಮೇಲೆ ಇನ್ನೂ ಕೆಲಸ ಮಾಡುತ್ತಿದ್ದೇನೆ.',
  'board.quick.text.waiting': 'ಪ್ರತಿಕ್ರಿಯೆಗಾಗಿ ಕಾಯುತ್ತಿದ್ದೇನೆ.',
  'board.quick.text.blocked': 'ಅಡಚಣೆ: ',
  'board.quick.text.done': 'ಈ ಕೆಲಸ ಪೂರ್ಣಗೊಂಡಿದೆ.',
  'board.create.step': '3 ರಲ್ಲಿ ಹಂತ {n}',
  'board.create.guidance': 'ನೀವು ಪೂರ್ಣಗೊಳಿಸಬಹುದಾದ ಒಂದು ಸ್ಪಷ್ಟ ಕೆಲಸವನ್ನು ಬರೆಯಿರಿ.',
  'board.create.back': 'ಹಿಂದೆ',
  'board.create.next': 'ಮುಂದೆ',
  'board.create.keepStatus': 'ಆಯ್ದ ಕಾಲಮ್ ಉಳಿಸಿ',
  'common.loading': 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
  'common.cancel': 'ರದ್ದು',
  'common.save': 'ಉಳಿಸಿ',
  'common.saving': 'ಉಳಿಸಲಾಗುತ್ತಿದೆ...',
  'common.submit': 'ಸಲ್ಲಿಸಿ',
  'common.submitting': 'ಸಲ್ಲಿಸಲಾಗುತ್ತಿದೆ...',
  'common.retry': 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
  'common.edit': 'ಸಂಪಾದಿಸಿ',
  'common.delete': 'ಅಳಿಸಿ',
  'common.close': 'ಮುಚ್ಚಿ',
  'common.location': 'ಸ್ಥಳ',

  'a11y.rowActions': 'ಸಾಲಿನ ಕ್ರಿಯೆಗಳು',

  'pagination.total': '{count} ಒಟ್ಟು',
  'pagination.pageOf': 'ಪುಟ {page} / {total}',
  'pagination.previous': 'ಹಿಂದಿನ',
  'pagination.next': 'ಮುಂದಿನ',

  'unit.hours': 'ಗಂ',
  'unit.days': 'ದಿ',

  'lang.label': 'ಭಾಷೆ',
  'lang.english': 'English',
  'lang.kannada': 'ಕನ್ನಡ',
  'lang.odia': 'ଓଡ଼ିଆ',
  'lang.hindi': 'हिन्दी',

  'login.brand.eyebrow': 'ಸಮಯ ಮತ್ತು ಹಾಜರಾತಿ',
  'login.brand.title': 'ಪಂಚ್ ಇನ್,\nಟ್ರ್ಯಾಕ್‌ನಲ್ಲಿ ಇರಿ.',
  'login.brand.subtitle': 'ಗಂಟೆಗಳು, ಕಾರ್ಯಗಳು ಮತ್ತು ರಜೆಯನ್ನು ಒಂದೇ ಸ್ಥಳದಿಂದ ಟ್ರ್ಯಾಕ್ ಮಾಡಿ.',
  'login.brand.footer': 'ಸಿಬ್ಬಂದಿ ಪ್ರವೇಶ ಮಾತ್ರ.',
  'login.signIn': 'ಸೈನ್ ಇನ್',
  'login.signInHint': 'ನಿಮ್ಮ ಕೆಲಸದ ಇಮೇಲ್ ಮತ್ತು ಪಾಸ್‌ವರ್ಡ್ ನಮೂದಿಸಿ.',
  'login.email': 'ಇಮೇಲ್',
  'login.password': 'ಪಾಸ್‌ವರ್ಡ್',
  'login.passwordPlaceholder': 'ಪಾಸ್‌ವರ್ಡ್ ನಮೂದಿಸಿ',
  'login.signingIn': 'ಸೈನ್ ಇನ್ ಆಗುತ್ತಿದೆ...',
  'login.emailPasswordRequired': 'ಇಮೇಲ್ ಮತ್ತು ಪಾಸ್‌ವರ್ಡ್ ಅಗತ್ಯ',
  'login.togglePassword': 'ಪಾಸ್‌ವರ್ಡ್ ಗೋಚರತೆ ಬದಲಿಸಿ',
  'login.mfa.title': 'ಎರಡು ಹಂತದ ಪರಿಶೀಲನೆ',
  'login.mfa.hint': 'ನಿಮ್ಮ authenticator ಅಪ್ಲಿಕೇಶನ್‌ನಿಂದ 6-ಅಂಕಿಯ ಕೋಡ್ ನಮೂದಿಸಿ.',
  'login.mfa.code': 'ಪರಿಶೀಲನೆ ಕೋಡ್',
  'login.mfa.verify': 'ಪರಿಶೀಲಿಸಿ',
  'login.mfa.verifying': 'ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ...',
  'login.mfa.codeRequired': 'authenticator ಅಪ್ಲಿಕೇಶನ್‌ನಿಂದ 6-ಅಂಕಿಯ ಕೋಡ್ ನಮೂದಿಸಿ',
  'login.setup.title': 'ಎರಡು ಹಂತದ ಪರಿಶೀಲನೆ ಹೊಂದಿಸಿ',
  'login.setup.hint': 'HR ಮತ್ತು admin ಖಾತೆಗಳಿಗೆ ಎರಡು ಹಂತದ ಪರಿಶೀಲನೆ ಅಗತ್ಯ. ಸುಮಾರು ಒಂದು ನಿಮಿಷ.',
  'login.setup.scanHint':
    'Google Authenticator, Microsoft Authenticator, ಅಥವಾ 1Password ನಂತಹ authenticator ಅಪ್ಲಿಕೇಶನ್‌ನೊಂದಿಗೆ ಈ QR ಕೋಡ್ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ.',
  'login.setup.qrAlt': 'Authenticator QR ಕೋಡ್',
  'login.setup.manualSummary': 'ಸ್ಕ್ಯಾನ್ ಮಾಡಲಾಗುವುದಿಲ್ಲವೇ? ಕೀಯನ್ನು ಹಸ್ತಚಾಲಿತವಾಗಿ ನಮೂದಿಸಿ',
  'login.setup.manualHint': 'ನಿಮ್ಮ authenticator ಅಪ್ಲಿಕೇಶನ್‌ನಲ್ಲಿ ಈ ಕೀಯನ್ನು ನಮೂದಿಸಿ:',
  'login.setup.codeLabel': 'ಅಪ್ಲಿಕೇಶನ್‌ನಿಂದ 6-ಅಂಕಿಯ ಕೋಡ್ ನಮೂದಿಸಿ',
  'login.setup.enabling': 'ಸಕ್ರಿಯಗೊಳಿಸಲಾಗುತ್ತಿದೆ...',
  'login.setup.enable': 'ಎರಡು ಹಂತದ ಪರಿಶೀಲನೆ ಆನ್ ಮಾಡಿ',
  'login.setup.codeRequired': 'authenticator ಅಪ್ಲಿಕೇಶನ್‌ನಲ್ಲಿ ತೋರಿಸಿದ 6-ಅಂಕಿಯ ಕೋಡ್ ನಮೂದಿಸಿ',

  'app.loading': 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',

  'footer.text': 'Teams · ಬಿಲ್ಡ್ {version}',

  'nav.self': 'ವೈಯಕ್ತಿಕ',
  'nav.today': 'ಇಂದು',
  'nav.myRequests': 'ನನ್ನ ವಿನಂತಿಗಳು',
  'nav.board': 'ಬೋರ್ಡ್',
  'nav.teamBoard': 'ಟೀಂ ಬೋರ್ಡ್',
  'nav.history': 'ಇತಿಹಾಸ',
  'nav.holidays': 'ರಜೆ ದಿನಗಳು',
  'nav.handbook': 'ಹ್ಯಾಂಡ್‌ಬುಕ್',
  'nav.announcements': 'ಘೋಷಣೆಗಳು',

  'meta.today.title': 'ಇಂದು',
  'meta.today.subtitle': 'ಪಂಚ್ ಇನ್/ಔಟ್ ಮತ್ತು ನಿಮ್ಮ ದಿನ ಹೇಗಿದೆ',
  'meta.today.exemptSubtitle': 'Your tasks, leave, and updates for today',
  'meta.board.title': 'ಬೋರ್ಡ್',
  'meta.board.subtitle': 'ನಿಮ್ಮ ವೈಯಕ್ತಿಕ to-do ಬೋರ್ಡ್ — ಕಾರ್ಡ್‌ಗಳನ್ನು ಕಾಲಮ್‌ಗಳ ನಡುವೆ ಎಳೆಯಿರಿ',
  'meta.teamBoard.title': 'ಟೀಂ ಬೋರ್ಡ್',
  'meta.teamBoard.subtitle': 'ಎಲ್ಲರ ಕಾರ್ಡ್‌ಗಳು — ಸರಿಸಿ, ಸಂಪಾದಿಸಿ ಮತ್ತು ಅಳಿಸಿ',
  'meta.my_requests.title': 'ನನ್ನ ವಿನಂತಿಗಳು',
  'meta.my_requests.subtitle': 'ನೀವು ಸಲ್ಲಿಸಿದ ರಜೆ, ತಡ ಮತ್ತು ಬೇಗ ಹೊರಡುವಿಕೆ',
  'meta.history.title': 'ಇತಿಹಾಸ',
  'meta.history.subtitle': 'ನಿಮ್ಮ ಪಂಚ್ ಇತಿಹಾಸ',
  'meta.handbook.title': 'ಹ್ಯಾಂಡ್‌ಬುಕ್',
  'meta.handbook.subtitle': 'ಘೋಷಣೆಗಳು, ನಿಯಮಗಳು, HR ನೀತಿ ಮತ್ತು ರಜೆ ದಿನಗಳು',

  'role.employee': 'ಉದ್ಯೋಗಿ',
  'role.hr': 'HR',
  'role.admin': 'Admin',
  'shell.logout': 'ಲಾಗ್ ಔಟ್',
  'shell.openNav': 'ನ್ಯಾವಿಗೇಶನ್ ತೆರೆಯಿರಿ',
  'shell.closeNav': 'ನ್ಯಾವಿಗೇಶನ್ ಮುಚ್ಚಿ',
  'shell.themeLight': 'ಲೈಟ್ ಥೀಮ್‌ಗೆ ಬದಲಿಸಿ',
  'shell.themeDark': 'ಡಾರ್ಕ್ ಥೀಮ್‌ಗೆ ಬದಲಿಸಿ',
  'shell.primaryNav': 'ಮುಖ್ಯ ನ್ಯಾವಿಗೇಶನ್',
  'shell.more': 'ಇನ್ನಷ್ಟು',
  'shell.moreHint': 'ನಿಮಗೆ ಲಭ್ಯವಿರುವ ಪುಟಗಳು ಮತ್ತು ಖಾತೆ ನಿಯಂತ್ರಣಗಳು.',
  'shell.accountControls': 'ಖಾತೆ ನಿಯಂತ್ರಣಗಳು',
  'shell.muteSounds': 'ಧ್ವನಿಗಳನ್ನು ಮ್ಯೂಟ್ ಮಾಡಿ',
  'shell.enableSounds': 'ಧ್ವನಿಗಳನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ',

  'notify.title': 'ಅಧಿಸೂಚನೆಗಳು',
  'notify.markAllRead': 'ಎಲ್ಲವನ್ನೂ ಓದಿದೆ ಎಂದು ಗುರುತಿಸಿ',
  'notify.enablePush': 'ಪುಶ್ ಅಧಿಸೂಚನೆಗಳನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ',
  'notify.enabling': 'ಸಕ್ರಿಯಗೊಳಿಸಲಾಗುತ್ತಿದೆ...',
  'notify.empty': 'ಇನ್ನೂ ಅಧಿಸೂಚನೆಗಳಿಲ್ಲ.',
  'notify.justNow': 'ಈಗ',
  'notify.minutesAgo': '{n} ನಿಮಿ ಹಿಂದೆ',
  'notify.hoursAgo': '{n} ಗಂಟೆ ಹಿಂದೆ',
  'notify.daysAgo': '{n} ದಿನ ಹಿಂದೆ',
  'notify.pushEnabled': 'ಪುಶ್ ಅಧಿಸೂಚನೆಗಳು ಸಕ್ರಿಯಗೊಂಡಿವೆ.',
  'notify.pushFailed': 'ಪುಶ್ ಅಧಿಸೂಚನೆಗಳನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಲಿಲ್ಲ.',

  'dashboard.loading': 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
  'dashboard.error': 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ಲೋಡ್ ಮಾಡಲಾಗಲಿಲ್ಲ.',
  'dashboard.onLeave': 'ರಜೆಯಲ್ಲಿ',
  'dashboard.onClock': 'ಕ್ಲಾಕ್‌ನಲ್ಲಿ',
  'dashboard.offClock': 'ಕ್ಲಾಕ್ ಹೊರಗೆ',
  'dashboard.attendanceExempt': 'Attendance exempt',
  'dashboard.attendanceNotRequired': 'No punch-in required',
  'dashboard.attendanceExemptHint': 'Your account is not part of attendance tracking.',
  'dashboard.onLeaveToday': 'ನೀವು ಇಂದು ಅನುಮೋದಿತ ರಜೆಯಲ್ಲಿದ್ದೀರಿ',
  'dashboard.onLeaveDisabled': 'ರಜೆಯಲ್ಲಿರುವಾಗ ಪಂಚ್ ಇನ್ ನಿಷ್ಕ್ರಿಯ.',
  'dashboard.inSince': '{time} ರಿಂದ ಒಳಗೆ',
  'dashboard.soFar': 'ಇಲ್ಲಿಯವರೆಗೆ',
  'dashboard.notPunchedIn': 'ಪಂಚ್ ಇನ್ ಆಗಿಲ್ಲ',
  'dashboard.punchInHint': 'ಕೆಲಸ ಪ್ರಾರಂಭಿಸಿದಾಗ ಪಂಚ್ ಇನ್ ಮಾಡಿ.',
  'dashboard.punchIn': 'ಪಂಚ್ ಇನ್',
  'dashboard.punchOut': 'ಪಂಚ್ ಔಟ್',
  'dashboard.stat.today': 'ಇಂದು',
  'dashboard.stat.week': 'ಈ ವಾರ',
  'dashboard.stat.leaveLeft': 'ಬಾಕಿ ರಜೆ',
  'dashboard.stat.openCards': 'ತೆರೆದ ಕಾರ್ಡ್‌ಗಳು',
  'dashboard.myTasks': 'ನನ್ನ ಕಾರ್ಯಗಳು',
  'dashboard.myTasksHint': 'ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಬೋರ್ಡ್‌ನಲ್ಲಿ ತೆರೆದ ಕಾರ್ಡ್‌ಗಳು.',
  'dashboard.viewBoard': 'ಬೋರ್ಡ್ ತೆರೆಯಿರಿ',
  'dashboard.noOpenTasks': 'ತೆರೆದ ಕಾರ್ಯಗಳಿಲ್ಲ — ನಿಮ್ಮ ಬೋರ್ಡ್ ಸ್ಪಷ್ಟ.',
  'dashboard.leave': 'ರಜೆ',
  'dashboard.leaveThrough': '{date} ವರೆಗೆ ರಜೆಯಲ್ಲಿ',
  'dashboard.days': 'ದಿನ(ಗಳು)',
  'dashboard.upcomingLeave': 'ಮುಂದಿನ ರಜೆ: {start} – {end}.',
  'dashboard.noLeaveScheduled': 'ಯಾವುದೇ ಅನುಮೋದಿತ ರಜೆ ನಿಗದಿಯಿಲ್ಲ.',
  'dashboard.pendingRequests': '{n} ವಿನಂತಿ(ಗಳು) ಅನುಮೋದನೆಗಾಗಿ ಬಾಕಿ.',
  'dashboard.yourLeave': 'ನಿಮ್ಮ ರಜೆ',
  'dashboard.noLeaveTypes': 'ಇನ್ನೂ ರಜೆ ಪ್ರಕಾರಗಳನ್ನು ಹೊಂದಿಸಲಾಗಿಲ್ಲ.',
  'dashboard.announcements': 'ಘೋಷಣೆಗಳು',
  'dashboard.noAnnouncements': 'ಇನ್ನೂ ಘೋಷಣೆಗಳಿಲ್ಲ.',
  'dashboard.toast.punchedInZone': '{zone} ಗೆ ಪಂಚ್ ಇನ್.',
  'dashboard.toast.punchedIn': 'ನೀವು ಪಂಚ್ ಇನ್ ಆಗಿದ್ದೀರಿ.',
  'dashboard.toast.punchedInLate': 'ನೀವು {minutes} ನಿಮಿಷ ತಡವಾಗಿ ಬಂದಿದ್ದೀರಿ.',
  'dashboard.toast.punchedOut': 'ನೀವು ಪಂಚ್ ಔಟ್ ಆಗಿದ್ದೀರಿ.',

  'punch.board.emptyTitle': 'ಇಂದು ನೀವು ಏನು ಕೆಲಸ ಮಾಡುತ್ತಿದ್ದೀರಿ?',
  'punch.board.emptyHint': 'ಇಂದಿನ ಕೆಲಸವನ್ನು ಸೇರಿಸಿ, ಅಥವಾ ನಿಮಗೆ ನಿಯೋಜಿತ ಕೆಲಸವಿಲ್ಲ ಎಂದು ದಾಖಲಿಸಿ.',
  'punch.board.pickWorkTitle': 'ಇಂದು ನೀವು ಏನು ಕೆಲಸ ಮಾಡುತ್ತಿದ್ದೀರಿ?',
  'punch.board.pickWorkHint': 'ಕೆಳಗೆ ಇಂದಿನ ಯೋಜನೆ ರೂಪಿಸಿ. ಗುರುತು ಮಾಡಿದ ಕೆಲಸ ಆಯ್ಕೆಯಾಗಿದೆ; ತೆಗೆಯಲು ಮತ್ತೆ ಟ್ಯಾಪ್ ಮಾಡಿ.',
  'punch.board.groupOngoing': 'ನಡೆಯುತ್ತಿರುವ',
  'punch.board.groupAvailable': 'ಲಭ್ಯ',
  'punch.board.groupBlocked': 'ನಿರ್ಬಂಧಿತ — ಗಮನ ಅಗತ್ಯ',
  'punch.board.blockedHint': 'ಇವು ಮಾಹಿತಿಗಾಗಿ ಕಾಣಿಸುತ್ತವೆ. ಮತ್ತೆ ಆರಂಭಿಸುವ ಮೊದಲು ಬೋರ್ಡ್‌ನಲ್ಲಿ ತಡೆಯನ್ನು ಪರಿಹರಿಸಿ.',
  'punch.board.todayPlan': 'ಇಂದಿನ ಯೋಜನೆ',
  'punch.board.selectedCount': '{n} ಆಯ್ಕೆ',
  'punch.board.selected': 'ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ',
  'punch.board.notSelected': 'ಆಯ್ಕೆ ಮಾಡಿಲ್ಲ',
  'punch.board.continueToday': 'ಇಂದು ಮುಂದುವರಿಸಿ',
  'punch.board.willMarkDone': 'ಇಂದಿನ ಯೋಜನೆಯಲ್ಲಿ ಇಲ್ಲ — ಮುಗಿದಿದೆ ಎಂದು ಗುರುತಿಸಲಾಗುತ್ತದೆ',
  'punch.board.startToday': 'ಇಂದು ಪ್ರಾರಂಭಿಸಿ',
  'punch.board.staysTodo': 'ಮಾಡಬೇಕಾದ ಪಟ್ಟಿಯಲ್ಲೇ ಇರುತ್ತದೆ',
  'punch.board.confirmSelected': '{n} ಕಾರ್ಯಗಳೊಂದಿಗೆ ದಿನ ಪ್ರಾರಂಭಿಸಿ',
  'punch.board.confirmNone': 'ನಡೆಯುತ್ತಿರುವ ಕಾರ್ಯಗಳನ್ನು ಮುಗಿದವು ಎಂದು ಗುರುತಿಸಿ',
  'punch.board.selectTask': 'ಕನಿಷ್ಠ ಒಂದು ಕಾರ್ಯವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
  'punch.board.blockedOnlyHint': 'ನಿಮಗೆ ನಿಯೋಜಿಸಿದ ಕಾರ್ಯಗಳು ನಿರ್ಬಂಧಿತವಾಗಿವೆ. ಗಮನ ಬೇಕಾದದ್ದನ್ನು ನೋಡಿ, ನಂತರ ಇಂದಿನ ಬೇರೆ ಕೆಲಸ ಸೇರಿಸಿ ಅಥವಾ ಲಭ್ಯ ಕೆಲಸವಿಲ್ಲ ಎಂದು ದಾಖಲಿಸಿ.',
  'punch.board.doingDoneTitle': 'ಇವು ಮುಗಿದವಾ?',
  'punch.board.doingDoneHint': 'ಮುಗಿಸಿದ ಕೆಲಸಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ.',
  'punch.board.pickTodoTitle': 'ನೀವು ಏನು ಮಾಡುತ್ತೀರಿ?',
  'punch.board.pickTodoHint': 'doing ಗೆ ಸೇರಿಸಲು ಕಾರ್ಯಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ.',
  'punch.board.skip': 'ಬಿಟ್ಟುಬಿಡಿ',
  'punch.board.confirm': 'ದೃಢೀಕರಿಸಿ',
  'punch.board.toast.markedDone': 'ಮುಗಿದೆ ಎಂದು ಗುರುತಿಸಲಾಗಿದೆ.',
  'punch.board.toast.started': 'doing ಗೆ ಸರಿಸಲಾಗಿದೆ.',
  'punch.board.toast.confirmed': 'ಕೆಲಸ ನವೀಕರಿಸಲಾಗಿದೆ.',

  'punchIn.title': 'ಪಂಚ್ ಇನ್',
  'punchIn.home.title': 'ದಯವಿಟ್ಟು ಮನೆ ಅಥವಾ ಕಚೇರಿಯಿಂದ ಪಂಚ್ ಇನ್ ಮಾಡಿ.',
  'punchIn.home.hint': 'ಕಚೇರಿಯಲ್ಲಿದ್ದರೆ Office ಎಂದು ತೋರಿಸುತ್ತದೆ. ಬೇರೆ ಎಲ್ಲೆಡೆ Home.',
  'punchIn.untagged': 'Sales ಪಂಚ್ — roster ನಲ್ಲಿ Sales ಎಂದು ತೋರಿಸುತ್ತದೆ. GPS ಸ್ಥಳ ಅಗತ್ಯವಿದೆ ಮತ್ತು ದಾಖಲಿಸಲಾಗುತ್ತದೆ; geofence ಇಲ್ಲ.',
  'punchIn.gettingLocation': 'ನಿಮ್ಮ ಸ್ಥಳ ಪಡೆಯಲಾಗುತ್ತಿದೆ...',
  'punchIn.atSite': '{name} ನಲ್ಲಿ',
  'punchIn.locationCaptured': 'ಸ್ಥಳ ಸೆರೆಹಿಡಿಯಲಾಗಿದೆ ({lat}, {lng})',
  'punchIn.refreshLocation': 'Refresh location',
  'punchIn.outsideSiteHint': 'Outside {name} radius: {distance} m away (radius {radius} m). Refresh location, check this site\'s location permission, or ask HR for help.',
  'punchIn.geoUnsupported': 'ಈ ಬ್ರೌಸರ್ geolocation ಅನ್ನು ಬೆಂಬಲಿಸುವುದಿಲ್ಲ.',
  'punchIn.geoDenied':
    'ಸ್ಥಳ ಪ್ರವೇಶ ನಿರಾಕರಿಸಲಾಗಿದೆ. ದಯವಿಟ್ಟು ಸ್ಥಳ ಪ್ರವೇಶ ಅನುಮತಿಸಿ ಮತ್ತು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  'punchIn.geoError': 'ನಿಮ್ಮ ಸ್ಥಳ ನಿರ್ಧರಿಸಲಾಗಲಿಲ್ಲ ({msg}).',
  'punchIn.you': 'ನೀವು',
  'punchIn.kmTo': '— {name} ಗೆ {km} km',
  'punchIn.placeDetails': 'ಸ್ಥಳದ ವಿವರಗಳು (ಐಚ್ಛಿಕ)',
  'punchIn.lookingUp': 'ಸ್ಥಳವನ್ನು ಹುಡುಕಲಾಗುತ್ತಿದೆ — ನೀವು ಈಗಲೇ ಪಂಚ್ ಮಾಡಬಹುದು.',
  'punchIn.placeName': 'ಸ್ಥಳದ ಹೆಸರು (ಐಚ್ಛಿಕ)',
  'punchIn.area': 'ಪ್ರದೇಶ (ಐಚ್ಛಿಕ)',
  'punchIn.nameHint': 'ನಿಮ್ಮ GPS ಸ್ಥಳ ಸಾಕು. ಬೇಕಿದ್ದರೆ ಸ್ಥಳದ ವಿವರಗಳನ್ನು ಸೇರಿಸಿ ಅಥವಾ ತಿದ್ದಿ, ಇಲ್ಲವೇ ಖಾಲಿ ಬಿಡಿ. ಹೋಟೆಲ್ ಅಥವಾ Maps ಲಿಂಕ್ ಅಗತ್ಯವಿಲ್ಲ.',
  'punchIn.punchingIn': 'ಪಂಚ್ ಇನ್ ಆಗುತ್ತಿದೆ...',
  'punchIn.fallbackHome': 'ಮನೆ',
  'punchIn.fallbackField': 'ಕ್ಷೇತ್ರ',

  'punchOut.title': 'ಪಂಚ್ ಔಟ್',
  'punchOut.home.title': 'ದಯವಿಟ್ಟು ಮನೆ ಅಥವಾ ಕಚೇರಿಯಿಂದ ಪಂಚ್ ಔಟ್ ಮಾಡಿ.',
  'punchOut.untagged': 'ಕ್ಲಾಕ್ ಔಟ್. Sales ಪಂಚ್‌ಗಳಿಗೆ GPS ಸ್ಥಳ ಅಗತ್ಯವಿದೆ ಮತ್ತು ದಾಖಲಿಸಲಾಗುತ್ತದೆ.',
  'punchOut.punchingOut': 'ಪಂಚ್ ಔಟ್ ಆಗುತ್ತಿದೆ...',

  'requests.new': 'ಹೊಸ ವಿನಂತಿ',
  'requests.error': 'ವಿನಂತಿಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗಲಿಲ್ಲ.',
  'requests.empty': 'ಇನ್ನೂ ವಿನಂತಿಗಳಿಲ್ಲ',
  'requests.edit': 'ವಿನಂತಿ ಸಂಪಾದಿಸಿ',
  'requests.fullRequest': 'ಪೂರ್ಣ ವಿನಂತಿ',
  'requests.type': 'ಪ್ರಕಾರ',
  'requests.type.leave': 'ರಜೆ',
  'requests.type.late': 'ತಡ',
  'requests.type.early_leaving': 'ಬೇಗ ಹೊರಡುವಿಕೆ',
  'requests.type.other': 'ಇತರೆ',
  'requests.startDate': 'ಪ್ರಾರಂಭ ದಿನಾಂಕ',
  'requests.endDate': 'ಅಂತ್ಯ ದಿನಾಂಕ',
  'requests.halfDay': 'ಅರ್ಧ ದಿನ',
  'requests.leaveType': 'ರಜೆ ಪ್ರಕಾರ',
  'requests.selectLeaveType': 'ರಜೆ ಪ್ರಕಾರ ಆಯ್ಕೆಮಾಡಿ...',
  'requests.leaveTypeLabel': '{name} — {remaining} / {quota} ಬಾಕಿ',
  'requests.reasonCategory': 'ಕಾರಣ ವರ್ಗ',
  'requests.selectCategory': 'ವರ್ಗ ಆಯ್ಕೆಮಾಡಿ...',
  'requests.reason': 'ಕಾರಣ',
  'requests.date': 'ದಿನಾಂಕ(ಗಳು)',
  'requests.status': 'ಸ್ಥಿತಿ',
  'requests.businessDays': '≈ {n} ವ್ಯಾಪಾರ ದಿನ(ಗಳು).',
  'requests.lateHint': 'ಟ್ರ್ಯಾಕಿಂಗ್‌ಗಾಗಿ ದಾಖಲಿಸಲಾಗಿದೆ, ಅನುಮೋದನೆ ಅಗತ್ಯವಿಲ್ಲ.',
  'requests.error.datesRequired': 'ಪ್ರಾರಂಭ ಮತ್ತು ಅಂತ್ಯ ದಿನಾಂಕ ಅಗತ್ಯ.',
  'requests.error.leaveTypeRequired': 'ರಜೆ ಪ್ರಕಾರ ಅಗತ್ಯ.',
  'requests.error.dateRequired': 'ದಿನಾಂಕ ಅಗತ್ಯ.',
  'requests.error.reasonRequired': 'ಕಾರಣ ಅಗತ್ಯ.',
  'requests.toast.updated': 'ವಿನಂತಿ ನವೀಕರಿಸಲಾಗಿದೆ.',
  'requests.toast.submitted': 'ವಿನಂತಿ ಸಲ್ಲಿಸಲಾಗಿದೆ.',
  'requests.toast.deleted': 'ವಿನಂತಿ ಅಳಿಸಲಾಗಿದೆ.',
  'requests.confirmDelete': 'ಈ ವಿನಂತಿಯನ್ನು ಅಳಿಸುವುದೇ?',
  'requests.status.pending': 'ಬಾಕಿ',
  'requests.status.approved': 'ಅನುಮೋದಿತ',
  'requests.status.rejected': 'ತಿರಸ್ಕೃತ',
  'requests.status.logged': 'ದಾಖಲಿಸಲಾಗಿದೆ',
  'requests.category.sick': 'ಅನಾರೋಗ್ಯ',
  'requests.category.personal': 'ವೈಯಕ್ತಿಕ',
  'requests.category.vacation': 'ರಜೆ',
  'requests.category.family': 'ಕುಟುಂಬ',
  'requests.category.bereavement': 'ಶೋಕ',
  'requests.category.menstrual': 'ಋತುಸ್ರಾವ',
  'requests.category.other': 'ಇತರೆ',

  'board.noWorkToday': 'ಇಂದು ನನ್ನಿಗೆ ಕೆಲಸವಿಲ್ಲ',
  'board.loggedToday': 'ಇಂದು ದಾಖಲಿಸಲಾಗಿದೆ',
  'board.loggedTodayTitle': 'ನೀವು ಈಗಾಗಲೇ ಇಂದು ದಾಖಲಿಸಿದ್ದೀರಿ.',
  'board.error': 'ನಿಮ್ಮ ಬೋರ್ಡ್ ಲೋಡ್ ಮಾಡಲಾಗಲಿಲ್ಲ.',
  'board.emptyBoard': 'ಇನ್ನೂ ಕಾರ್ಡ್‌ಗಳಿಲ್ಲ — ಪ್ರಾರಂಭಿಸಲು ಒಂದನ್ನು ಸೇರಿಸಿ.',
  'board.column.todo': 'ಮಾಡಬೇಕು',
  'board.column.doing': 'ಮಾಡುತ್ತಿದ್ದೇನೆ',
  'board.column.blocked': 'ನಿರ್ಬಂಧಿತ',
  'board.column.done': 'ಮುಗಿದಿದೆ',
  'board.columnAria': 'ಬೋರ್ಡ್ ಕಾಲಮ್',
  'board.addCard': 'ಕಾರ್ಡ್ ಸೇರಿಸಿ',
  'board.addCardTo': '{col} ಗೆ ಕಾರ್ಡ್ ಸೇರಿಸಿ',
  'board.editCard': 'ಕಾರ್ಡ್ ಸಂಪಾದಿಸಿ',
  'board.newCard': 'ಹೊಸ ಕಾರ್ಡ್ — {col}',
  'board.title': 'ಶೀರ್ಷಿಕೆ',
  'board.description': 'ವಿವರಣೆ',
  'board.error.titleRequired': 'ಶೀರ್ಷಿಕೆ ಅಗತ್ಯ.',
  'board.toast.updated': 'ಕಾರ್ಡ್ ನವೀಕರಿಸಲಾಗಿದೆ.',
  'board.toast.created': 'ಕಾರ್ಡ್ ರಚಿಸಲಾಗಿದೆ.',
  'board.toast.deleted': 'ಕಾರ್ಡ್ ಅಳಿಸಲಾಗಿದೆ.',
  'board.toast.moved': '{col} ಗೆ ಸ್ಥಳಾಂತರಿಸಲಾಗಿದೆ.',
  'board.toast.logged': 'ದಾಖಲಿಸಲಾಗಿದೆ.',
  'board.confirmDelete': '"{title}" ಅಳಿಸುವುದೇ?',
  'board.moveTo': '{col} ಗೆ ಸ್ಥಳಾಂತರಿಸಿ',
  'board.deleteCard': 'ಕಾರ್ಡ್ ಅಳಿಸಿ',
  'board.doneAt': 'ಮುಗಿದಿದೆ {date}',
  'board.fromLabel': '{label} ನಿಂದ',
  'board.myTask': 'ನಿಮ್ಮ ಕಾರ್ಯ',
  'board.source.commandCentre': 'Command Centre',
  'board.source.chiefOfStaff': 'Omar',
  'board.sharedProgress': 'Shared: {completed}/{total}', 'board.blockedReason': 'Blocked: {reason}', 'board.blockedExternal': 'Waiting on {name}', 'board.helpers': 'Helpers: {helpers}', 'board.blocking': 'Blocking {user}: {title}', 'board.toast.blocked': 'Task blocked and helpers notified.',
  'board.block.title': 'Block task', 'board.block.intro': 'Add helper tasks needed to unblock “{title}”.', 'board.block.reason': 'What is blocked?', 'board.block.modeLabel': 'Blocking type', 'board.block.modeHelpers': 'Hand over to teammate', 'board.block.modeExternal': 'External party', 'board.block.externalName': 'External party name', 'board.block.externalNamePlaceholder': 'e.g. Shafiq sir, vendor name', 'board.block.externalGuidance': 'Use this only when nobody inside the company can unblock it. Name the person or party and describe what is awaited above.', 'board.block.missingInfoCta': 'Add blocking info: name a teammate or external party.', 'board.block.setInfo': 'Set blocking info', 'board.block.firstNameGuidance': 'Enter the helper’s exact full first name. If more than one person has that name, select the right person below.', 'board.block.helperNumber': 'Helper {n}', 'board.block.helperFirstName': 'Helper first name', 'board.block.helperPerson': 'Helper', 'board.block.helperPersonPlaceholder': 'Select a teammate', 'board.block.selectedHelper': 'Selected: {name}', 'board.block.matches': 'Matching helpers', 'board.block.helperTask': 'Helper task', 'board.block.removeHelper': 'Remove helper', 'board.block.addHelper': 'Add another helper', 'board.block.submit': 'Block task',

  'teamBoard.readOnly': 'ಓದಲು ಮಾತ್ರ ಟೀಂ ನೋಟ',
  'teamBoard.filterAll': 'ಎಲ್ಲರೂ',
  'teamBoard.filterPeople': 'ವ್ಯಕ್ತಿಯಿಂದ ಫಿಲ್ಟರ್ ಮಾಡಿ',
  'teamBoard.people': 'ಜನರು',
  'teamBoard.peopleSelected': '{n} ಜನ',
  'teamBoard.selectPeople': 'ಜನರನ್ನು ಆಯ್ಕೆಮಾಡಿ',
  'teamBoard.error': 'ಟೀಂ ಬೋರ್ಡ್ ಲೋಡ್ ಮಾಡಲಾಗಲಿಲ್ಲ.',
  'teamBoard.emptyColumn': 'ಕಾರ್ಡ್‌ಗಳಿಲ್ಲ',
  'teamBoard.newCardFor': '{person} ಗಾಗಿ ಹೊಸ ಕಾರ್ಡ್ — {col}',
  'teamBoard.composerLabel': 'ಕಾರ್ಯ ನಿಯೋಜಿಸಿ',
  'teamBoard.composerPlaceholder': 'Type @ to add people', 'teamBoard.composerTaskPlaceholder': 'Task for selected people', 'teamBoard.removeRecipient': 'Remove {name}',
  'teamBoard.composerInvalid': 'ಸಲಹೆಗಳಿಂದ ವ್ಯಕ್ತಿಯನ್ನು ಆಯ್ಕೆಮಾಡಿ ಮತ್ತು ಕಾರ್ಯ ನಮೂದಿಸಿ.',
  'teamBoard.assign': 'ನಿಯೋಜಿಸಿ',
  'teamBoard.searchCards': 'ಕಾರ್ಡ್‌ಗಳು ಅಥವಾ ಜನರನ್ನು ಹುಡುಕಿ',
  'teamBoard.searchPeople': 'ಜನರನ್ನು ಹುಡುಕಿ',
  'teamBoard.noPeopleMatch': 'ಹೊಂದುವ ಜನರಿಲ್ಲ.',
  'teamBoard.summary': '{total} ಕಾರ್ಡ್‌ಗಳಲ್ಲಿ {shown} ತೋರಿಸಲಾಗುತ್ತಿದೆ',
  'teamBoard.emptyBoard': 'ಇನ್ನೂ ತಂಡದ ಕಾರ್ಡ್‌ಗಳಿಲ್ಲ.',
  'teamBoard.emptySearch': 'ನಿಮ್ಮ ಹುಡುಕಾಟಕ್ಕೆ ಕಾರ್ಡ್‌ಗಳಿಲ್ಲ.',
  'teamBoard.clearFilters': 'ಫಿಲ್ಟರ್‌ಗಳನ್ನು ತೆರವುಗೊಳಿಸಿ',
  'teamBoard.attention': 'Attention',
  'teamBoard.attentionTitle': 'Needs attention',
  'teamBoard.attentionEmpty': 'Nothing blocked, nothing stale. Every board is moving.',
  'teamBoard.attentionBlocked': 'Blocked ({n})',
  'teamBoard.attentionStale': 'Stuck in Doing 3+ days ({n})',
  'teamBoard.attentionStaleAge': '{age} in Doing',
  'teamBoard.ageDays': '{n}d',
  'teamBoard.usage': 'Usage',
  'teamBoard.usageTitle': 'Board usage',
  'teamBoard.usageName': 'Name',
  'teamBoard.usageLastOpened': 'Last opened',
  'teamBoard.usageOpens': 'Opens',
  'teamBoard.usageNever': 'Never',
  'teamBoard.usageAgo': '{n}d ago',
  'fieldAttention.subtitle': 'Blocked chains and work sitting in Doing across your field team.',
  'fieldAttention.error': 'Could not load the field board.',
  'teamBoard.activity': 'ಚಟುವಟಿಕೆ',
  'teamBoard.activityTitle': 'ಬೋರ್ಡ್ ಚಟುವಟಿಕೆ',
  'teamBoard.activityLoading': 'ಚಟುವಟಿಕೆ ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
  'teamBoard.activityEmpty': 'ಇನ್ನೂ ಚಟುವಟಿಕೆ ಇಲ್ಲ.',
  'teamBoard.activitySystem': 'ಸಿಸ್ಟಮ್',

  'noWork.title': 'ಇಂದು ಕೆಲಸವಿಲ್ಲ?',
  'noWork.intro':
    'ಇಂದು ನಿಯೋಜಿತ ಕೆಲಸವಿಲ್ಲವೇ? ಬದಲಾಗಿ ನೀವು ಎತ್ತಿಕೊಂಡದ್ದನ್ನು ದಾಖಲಿಸಿ — housekeeping, ನಿಮ್ಮ ಕಾರ್ಡ್, ಅಥವಾ ಸಹಾಯ ಮಾಡಿದ ಬಗ್ಗೆ ಟಿಪ್ಪಣಿ.',
  'noWork.kind.housekeeping': 'Housekeeping',
  'noWork.kind.ownCard': 'ನನ್ನ ಕಾರ್ಡ್‌ಗಳಲ್ಲಿ ಒಂದು',
  'noWork.kind.note': 'ಚಿಕ್ಕ ಟಿಪ್ಪಣಿ',
  'noWork.housekeepingItem': 'Housekeeping ಐಟಂ',
  'noWork.noHousekeeping': 'Housekeeping ಐಟಂಗಳನ್ನು ಇನ್ನೂ ಹೊಂದಿಸಲಾಗಿಲ್ಲ — ಬೇರೆ ಆಯ್ಕೆ ಮಾಡಿ.',
  'noWork.choose': '— ಆಯ್ಕೆಮಾಡಿ —',
  'noWork.yourCard': 'ನಿಮ್ಮ ಕಾರ್ಡ್',
  'noWork.noCards': 'ತೆರೆದ to-do ಅಥವಾ blocked ಕಾರ್ಡ್‌ಗಳಿಲ್ಲ — ಬೇರೆ ಆಯ್ಕೆ ಮಾಡಿ.',
  'noWork.note': 'ಟಿಪ್ಪಣಿ',
  'noWork.notePlaceholder': 'ಉದಾ. Ravi ಗೆ site survey ನಲ್ಲಿ ಸಹಾಯ ಮಾಡಿದೆ',
  'noWork.error.pickOne': 'ಕೆಳಗಿನ ಮೂರು ಆಯ್ಕೆಗಳಲ್ಲಿ ಒಂದನ್ನು ಆಯ್ಕೆಮಾಡಿ.',
  'noWork.logIt': 'ದಾಖಲಿಸಿ',
  'noWork.recent': 'ಇತ್ತೀಚಿನ',
  'noWork.describe.ownCard': 'ನನ್ನ ಕಾರ್ಡ್‌ಗಳಲ್ಲಿ ಒಂದು',
  'noWork.describe.housekeeping': 'housekeeping',

  'history.error': 'ಕೆಲಸದ ಲಾಗ್‌ಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗಲಿಲ್ಲ.',
  'history.empty': 'ಇನ್ನೂ ಕೆಲಸದ ಲಾಗ್‌ಗಳಿಲ್ಲ',
  'history.date': 'ದಿನಾಂಕ',
  'history.in': 'ಒಳಗೆ',
  'history.out': 'ಹೊರಗೆ',
  'history.duration': 'ಅವಧಿ',
  'history.site': 'ಸೈಟ್',
  'history.tasks': 'ಕಾರ್ಯಗಳು',
  'history.inProgress': 'ಪ್ರಗತಿಯಲ್ಲಿದೆ',
  'history.remote': 'Remote',

  'holidays.subtitle': 'ರಾಷ್ಟ್ರೀಯ ಮತ್ತು ಕಂಪನಿ ರಜೆ ದಿನಗಳು.',
  'holidays.error': 'ರಜೆ ದಿನಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗಲಿಲ್ಲ.',
  'holidays.national': 'ರಾಷ್ಟ್ರೀಯ ರಜೆ ದಿನಗಳು',
  'holidays.company': 'ಕಂಪನಿ ರಜೆ ದಿನಗಳು',
  'holidays.upcoming': 'ಮುಂದಿನ',
  'holidays.empty': 'ಯಾವುದೇ ರಜೆ ದಿನಗಳು ಪಟ್ಟಿ ಮಾಡಲಾಗಿಲ್ಲ.',

  'announcements.subtitle': 'HR ನಿಂದ ಕಂಪನಿ-ವ್ಯಾಪಿ ನವೀಕರಣಗಳು.',
  'announcements.error': 'ಘೋಷಣೆಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗಲಿಲ್ಲ.',
  'announcements.empty': 'ಇನ್ನೂ ಘೋಷಣೆಗಳಿಲ್ಲ.',
  'announcements.authorFallback': 'HR',

  'policy.error': 'ಈ ನೀತಿಯನ್ನು ಲೋಡ್ ಮಾಡಲಾಗಲಿಲ್ಲ.',

  'leave.hint.endBeforeStart': 'ಅಂತ್ಯ ದಿನಾಂಕ ಪ್ರಾರಂಭ ದಿನಾಂಕದ ನಂತರ ಅಥವಾ ಸಮಾನವಾಗಿರಬೇಕು.',
  'leave.hint.startTooPast': 'ಪ್ರಾರಂಭ ದಿನಾಂಕ 7 ದಿನಗಳ ಹಿಂದೆಗಿಂತ ಹಿಂದೆ ಇರಬಾರದು.',
  'leave.hint.startTooFuture': 'ಪ್ರಾರಂಭ ದಿನಾಂಕ 1 ವರ್ಷಕ್ಕಿಂತ ಮುಂದೆ ಇರಬಾರದು.',
  'leave.hint.tooLong': 'ರಜೆ ವಿನಂತಿಗಳು 30 ದಿನಗಳನ್ನು ಮೀರುವಂತಿಲ್ಲ.'
};

export default kn;
